import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import AccountLayout from 'layout/Account';

const AccountSettingsPage = Loadable(lazy(() => import('pages/account/Settings')));

const AccountRoutes = {
  path: '/account',
  element: <AccountLayout />,
  children: [
    {
      path: 'settings',
      element: <AccountSettingsPage />
    }
  ]
};

export default AccountRoutes;
